import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SalesOrderDetailCreateRequestDTO,
  SalesOrderDetailUpdateRequestDTO,
  SalesOrderDetailDeleteRequestDTO,
  SalesOrderDetailDTO,
  SalesOrderDetailList,
  SalesOrderDetailReadByIdRequestDTO,
  SalesOrderDetailReadBySalesOrderIdRequestDTO,
  SalesOrderDetailReadByItemIdRequestDTO,
  SalesOrderDetailReadBySalesOrderIdForImportRequestDTO,
  SalesOrderDetailUpsertBulkRequestDTO
} from './sales-order-detail.interface';

import {
  SalesOrderDetail_Create,
  SalesOrderDetail_Update,
  SalesOrderDetail_Delete,
  SalesOrderDetail_ReadById,
  SalesOrderDetail_ReadAll,
  SalesOrderDetail_ReadBySalesOrderId,
  SalesOrderDetail_ReadByItemId,
  SalesOrderDetail_ReadBySalesOrderIdForImport,
  SalesOrderDetail_UpsertBulk
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class SalesOrderDetailService {
  http = inject(HttpClient);

  SalesOrderDetail_Create(data: SalesOrderDetailCreateRequestDTO): Observable<SalesOrderDetailDTO> {
    return this.http.post<SalesOrderDetailDTO>(SalesOrderDetail_Create, data);
  }

  SalesOrderDetail_Update(data: SalesOrderDetailUpdateRequestDTO): Observable<SalesOrderDetailDTO> {
    return this.http.post<SalesOrderDetailDTO>(SalesOrderDetail_Update, data);
  }

  SalesOrderDetail_Delete(data: SalesOrderDetailDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(SalesOrderDetail_Delete, data);
  }

  SalesOrderDetail_ReadById(data: SalesOrderDetailReadByIdRequestDTO): Observable<SalesOrderDetailDTO> {
    return this.http.post<SalesOrderDetailDTO>(SalesOrderDetail_ReadById, data);
  }

  SalesOrderDetail_ReadAll(): Observable<SalesOrderDetailList> {
    return this.http.get<SalesOrderDetailList>(SalesOrderDetail_ReadAll);
  }

  SalesOrderDetail_ReadByOrderId(data: SalesOrderDetailReadBySalesOrderIdRequestDTO): Observable<SalesOrderDetailList> {
    return this.http.post<SalesOrderDetailList>(SalesOrderDetail_ReadBySalesOrderId, data);
  }

  SalesOrderDetail_ReadByItemId(data: SalesOrderDetailReadByItemIdRequestDTO): Observable<SalesOrderDetailList> {
    return this.http.post<SalesOrderDetailList>(SalesOrderDetail_ReadByItemId, data);
  }

  SalesOrderDetail_ReadBySalesOrderIdForImport(data: SalesOrderDetailReadBySalesOrderIdForImportRequestDTO): Observable<SalesOrderDetailList> {
    return this.http.post<SalesOrderDetailList>(SalesOrderDetail_ReadBySalesOrderIdForImport, data);
  }

  SalesOrderDetail_UpsertBulk(data: SalesOrderDetailUpsertBulkRequestDTO): Observable<SalesOrderDetailList> {
    return this.http.post<SalesOrderDetailList>(SalesOrderDetail_UpsertBulk, data);
  }
}
